export default function sortAppointments(appt1, appt2) {
  if (appt1.startTime <= appt2.startTime) {
    return -1;
  }
  return 1;
}
